define('superAdminMbSmpMatsView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!superAdminMbSmpMatsListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var MbSmpMatListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'mbsmpmatsListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteMbSmpMat: '.delete-mbsmpmat-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteMbSmpMat': 'onDeleteMbSmpMat'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'mbsmpmats'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteMbSmpMat: function(event){
            this.trigger('mbsmpmat:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'mbsmpmat-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code',
                        width: 30
                    }, {
                        label: _.i18n('common.name'),
                        name: 'name',
                        classes: 'mbsmpmat-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'name'
                    }, {
                        label: _.i18n('mbsmpmat.matColor'),
                        name: 'matColor',
                        classes: 'mbsmpmat-link',
                        formatter:  this.colorFormatter,
                        search: false,
                        index: 'matColor'
                    }, {
                        label: _.i18n('common.description'),
                        name: 'description',
                        classes: 'mbsmpmat-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'description'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-mbsmpmat-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'superAdmin/mbsmpmats' ?
                                App.getCurrentRoute() : 'superAdmin/mbsmpmats/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = MbSmpMatListView;
});
